import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex-1 min-w-0 truncate" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_3 = { class: "flex flex-col gap-0.5" }
const _hoisted_4 = { class: "pt-2 border-t border-gray-100" }
const _hoisted_5 = {
  key: 1,
  class: "space-y-3"
}

import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { ChevronDownIcon, ChevronLeftIcon } from '@heroicons/vue/20/solid'
import { CalendarDaysIcon } from '@heroicons/vue/24/outline'
import { DatePicker } from 'v-calendar'
import { computed, ref, watch } from 'vue'

import { useDropdownAnchor } from '@/composables/useDropdownAnchor'


export default {
  __name: 'ReportDateRangeFilter',
  props: {
  options: { type: Array, default: () => [] },
  selected: { type: String, default: '' },
  selectedLabel: { type: String, default: '' },
  customRange: { type: Object, default: null }
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const {
  setReference: setDateRef,
  setFloating: setDateFloat,
  floatingStyles: dateStyles
} = useDropdownAnchor({
  placement: 'bottom-end'
})

const today = computed(() => new Date())
const calendarRange = ref(null)
const showCustomRange = ref(false)

const displayLabel = computed(() => {
  if (props.selectedLabel) return props.selectedLabel
  const opt = props.options.find(o => o.value === props.selected)
  return opt?.label ?? props.selected ?? 'Select date range'
})

function onDatePopoverOpen() {
  const hasCustomRange =
    props.customRange?.start !== null &&
    props.customRange?.start !== undefined &&
    props.customRange?.end !== null &&
    props.customRange?.end !== undefined
  showCustomRange.value = !!hasCustomRange
}

function onCalendarRangeSelect(value, closePopover) {
  if (value?.start && value?.end) {
    const start = value.start instanceof Date ? value.start : new Date(value.start)
    const end = value.end instanceof Date ? value.end : new Date(value.end)
    if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
      emit('change', { start, end })
      showCustomRange.value = false
      if (typeof closePopover === 'function') {
        closePopover()
      }
    }
  }
}

watch(
  () => props.customRange,
  range => {
    if (!range?.start || !range?.end) {
      calendarRange.value = null
      return
    }
    const start = range.start instanceof Date ? range.start : new Date(range.start)
    const end = range.end instanceof Date ? range.end : new Date(range.end)
    if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
      calendarRange.value = { start, end }
    } else {
      calendarRange.value = null
    }
  },
  { immediate: true, deep: true }
)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Popover), {
    as: "div",
    class: "relative inline-block text-left"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverButton), {
        ref: _unref(setDateRef),
        class: "report-filter-pill inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500 min-w-0",
        onClick: onDatePopoverOpen
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CalendarDaysIcon), { class: "h-4 w-4 text-gray-500 shrink-0" }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(displayLabel.value), 1),
          _createVNode(_unref(ChevronDownIcon), {
            class: "h-4 w-4 text-gray-500 shrink-0 ml-0.5",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }, 512),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(PopoverPanel), {
              ref: _unref(setDateFloat),
              style: _normalizeStyle(_unref(dateStyles)),
              class: "z-50 w-72 overflow-y-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 p-4"
            }, {
              default: _withCtx(({ close }) => [
                (!showCustomRange.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-xs font-medium text-gray-500 uppercase tracking-wide" }, "Preset", -1)),
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (opt) => {
                          return (_openBlock(), _createBlock(_unref(PopoverButton), {
                            key: opt.value,
                            "data-test": "date-range-option",
                            class: "text-left text-sm text-gray-700 hover:bg-gray-100 rounded px-2 py-1.5 -mx-2",
                            onClick: $event => (_ctx.$emit('change', opt.value))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(opt.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "text-left text-sm text-gray-700 hover:bg-gray-100 rounded px-2 py-1.5 -mx-2 w-full flex items-center",
                          onClick: _cache[0] || (_cache[0] = $event => (showCustomRange.value = true))
                        }, " Custom range ")
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-sm text-gray-600 hover:text-gray-900 flex items-center gap-1 -ml-1",
                        onClick: _cache[1] || (_cache[1] = $event => (showCustomRange.value = false))
                      }, [
                        _createVNode(_unref(ChevronLeftIcon), {
                          class: "h-4 w-4",
                          "aria-hidden": "true"
                        }),
                        _cache[4] || (_cache[4] = _createTextVNode(" Presets ", -1))
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-xs font-medium text-gray-500 uppercase tracking-wide" }, "Custom range", -1)),
                      _createVNode(_unref(DatePicker), {
                        modelValue: calendarRange.value,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = $event => ((calendarRange).value = $event)),
                          value => onCalendarRangeSelect(value, close)
                        ],
                        modelModifiers: { range: true },
                        mode: "date",
                        "max-date": today.value
                      }, null, 8, ["modelValue", "max-date", "onUpdate:modelValue"])
                    ]))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        })
      ]))
    ]),
    _: 1
  }))
}
}

}